import React from 'react'
import Icon from 'react-native-vector-icons/Ionicons'
import styled, { useTheme } from 'styled-components/native'

import Typography from 'APP/Converse/Typography'

const Header = styled.View`
  position: relative;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.elementsBg};
  border-radius: 20px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding-top: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin * 1.5}px
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
`

const Title = styled.View`
  align-items: center;
`

const ButtonWrapper = styled.View`
  position: absolute;
  top: 0;
  right: ${({ theme }) => theme.metrics.baseMargin * 1.4}px;
  bottom: 0;
  justify-content: center;
  align-items: center;
  flex-grow: 0;
`

const Button = styled.TouchableOpacity`
  width: 25px;
  height: 25px;
`

interface Props {
  title: string
  onClose: () => void
}

const DrawerHeader = ({ title, onClose }: Props) => {
  const theme = useTheme()

  return (
    <Header testID="DRAWER_HEADER">
      <Title>
        <Typography variant="h4" color="text">
          {title}
        </Typography>
      </Title>
      <ButtonWrapper>
        <Button onPress={onClose}>
          <Icon name="arrow-down" color={theme.colors.text} size={25} />
        </Button>
      </ButtonWrapper>
    </Header>
  )
}

export default DrawerHeader
